import { FETCH_PRODUCT_STATUS_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
};

const productStatusListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_STATUS_LIST:
      return { list: action.payload };
    default:
      return state;
  }
};

export default productStatusListReducer;
